import React from 'react';

export function MenuButtonGrid({
  activeMenuButtons,
  onAppSectionChange,
  setMainMenuOpen,
  setSystemSubmenuOpen,
  systemSubmenuOpen
}) {
  return (
    <div className="hero-icons-grid">
      {activeMenuButtons.map(btnDef => {
        if (!btnDef) return null;

        // Section-Button (Dashboard, Tarife) — navigiert per onAppSectionChange
        if (btnDef.type === 'section' && onAppSectionChange) {
          return (
            <button
              key={btnDef.id}
              className="hero-icon-btn"
              onClick={() => {
                onAppSectionChange(btnDef.section);
                setMainMenuOpen(false);
                setSystemSubmenuOpen(false);
              }}
              type="button"
            >
              {btnDef.icon}
              <span className="hero-icon-label">{btnDef.label}</span>
            </button>
          );
        }

        // Submenu-Button (System)
        if (btnDef.type === 'submenu') {
          return (
            <button
              key={btnDef.id}
              className="hero-icon-btn"
              onClick={() => setSystemSubmenuOpen(!systemSubmenuOpen)}
              type="button"
            >
              {btnDef.icon}
              <span className="hero-icon-label">{btnDef.label}</span>
            </button>
          );
        }

        // Link-Button (Admin, Druck)
        if (btnDef.type === 'link') {
          return (
            <button
              key={btnDef.id}
              className="hero-icon-btn"
              onClick={() => { setMainMenuOpen(false); window.location.href = btnDef.href; }}
              type="button"
            >
              {btnDef.icon}
              <span className="hero-icon-label">{btnDef.label}</span>
            </button>
          );
        }

        return null;
      })}
    </div>
  );
}
